module.exports = __webpack_public_path__ + "img/c06_unittechironwheels_Normal_ua.f61a3632.webp";